<template>
<div style="margin:15px;">
  <div @click="goBack()" style="cursor:pointer; float:right;"><i class="fas fa-arrow-circle-left fa-2x" style="color:deepskyblue;"></i></div>
  <b-container fluid class="bv-example-row">
    <b-row>
      <b-col><blocInfostiers /></b-col>
    </b-row>
    <b-row>
      <b-col><blocTabs /></b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import blocInfostiers from './BlocInfosTiers'
import blocTabs from './BlocTabs'
import script from '../../../script/script.js'
import scriptTiers from '../../../script/script_tiers.js'

export default {
  components: {
    blocInfostiers,
    blocTabs
  },

  mounted: function () {
    this.verifyRight()
    this.detailsTiers(this.$route.params.id)
  },

  methods: {
    verifyRight: script.verifyRight,
    detailsTiers: scriptTiers.detailsTiers,
    goBack(){
      this.$store.commit("resetDocuments")
      this.$router.go(-1)
    }
  },
  computed:{
  }
}
</script>
<style>
.txtRight {
  text-align:right;
}
</style>
